const UserActionTypes = {
	SET_CURRENT_USER: 'SET_CURRENT_USER',
	TOGGLE_HIDDEN_MENU: 'TOGGLE_HIDDEN_MENU'
}

export default UserActionTypes;